export default function About() {
  return (
    <section id="about" data-testid="section-about" className="bg-sand">
      <div className="mx-auto max-w-[1100px] px-6 py-20 md:px-10 md:py-28 lg:py-32">
        <h2 className="section-heading max-w-[680px]">About Kat.</h2>

        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-16 md:grid-cols-[360px_1fr] md:gap-16 md:items-start">
          <div
            data-testid="about-photo"
            className="overflow-hidden"
            style={{
              aspectRatio: "1 / 1",
              width: "100%",
              maxWidth: "360px",
              borderRadius: "8px",
              border: "0.5px solid rgba(26,58,79,0.14)",
            }}
          >
            <img
              src="/about_kat.jpg"
              alt="Portrait of Kat Ryder"
              data-testid="about-photo-img"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center top",
                display: "block",
              }}
            />
          </div>

          <div className="max-w-[600px]">
            <p
              data-testid="about-copy-p1"
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontSize: "18px",
                lineHeight: 1.7,
                color: "rgba(26,58,79,0.88)",
              }}
            >
              {"My background is operations, strategic growth, and bringing new technology into traditional industries. Most recently I served as a chief executive at a law firm. Before that, I was VP of Operations Services and Technology at a rapidly scaling restaurant business. Kat Ryder Consulting is the same kind of work, just unbundled and project-based. I started it for owners and leadership teams who don\u2019t need a permanent C-suite hire, but do need someone who can sit in the seat for a defined stretch and leave them better off."}
            </p>

            <p
              data-testid="about-copy-p2"
              className="mt-5"
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontSize: "18px",
                lineHeight: 1.7,
                color: "rgba(26,58,79,0.88)",
              }}
            >
              {"Outside of work, I enjoy reading, traveling with my husband, and lakeside walks in Chicago with our dog Mr. Feeny. Our cat Cory holds down the apartment."}
            </p>

            <p
              className="mt-6"
              data-testid="about-location"
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontSize: "14px",
                color: "var(--color-soft-gray)",
              }}
            >
              Based in Chicago. Works with clients anywhere.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
